var StorageType = /* @__PURE__ */ ((StorageType2) => {
  StorageType2["NONE"] = "none";
  StorageType2["LOCAL"] = "local";
  StorageType2["REMOTE"] = "remote";
  return StorageType2;
})(StorageType || {});

export { StorageType };
//# sourceMappingURL=storage-type.js.map
